module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J. M. Hayes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("J M \"Mike\" Hayes was born and raised on the flat earth of Central Kansas. He studied anthropology at Wichita State University and the University of Arizona and lives in Tucson with his wife and a small herd of German Shepherds.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ghZCVF/tc-custom/9781464202841.jpg?1716906082280",
      "alt": "This image is the cover for the book Spirit and the Skull"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Spirit and the Skull\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Murder is unthinkable to The People—a Paleolithic tribe crossing Alaska. For The People, among the first undocumented immigrants to enter the Americas, murder isn't merely tragic, it's forbidden. Murder poisons the entire tribe and puts it at odds with nature, the Spirits, and the mighty Earth Mother. A murderer must be removed in order to set the world back in balance.")]), _c('p', [_vm._v("Raven is the aging Spirit Man to a band where a member has been garroted. Worse, witchcraft is involved—another appalling violation of The People's beliefs. A woman claiming to be The Earth Mother declares only Raven can solve the crimes and restore The People to harmony. But Raven isn't a Spirit Man by vocation. He's an agnostic—his band needed someone for the job and he needed to secure his place with them. He begins having dreams of a strange man holding his, the Spirit Man's, skull in his hands. How will a man who doubts the authenticity of The Earth Mother as a goddess satisfy her demands? What if she and the dreams of some future are both real and solving the crimes must lead to his death? An impossible situation becomes more terrible as Raven realizes he's falling in love with a young woman of his band who, he suspects, is the guilty party.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0